// Configuration object for the mug design
const defaultTemplates = {
  lovemugBlack: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 60.5,
          yPercent: 34,
          rotation: -77,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33,
          yPercent: 53.5,
          rotation: 25,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 60.5,
          yPercent: 34,
          rotation: -77,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33.5,
          yPercent: 53.5,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 50,
          yPercent: 68.5,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 60.5,
          yPercent: 34,
          rotation: -77,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 34,
          yPercent: 53.5,
          rotation: 25,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49.25,
          yPercent: 69,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 68.5,
          yPercent: 52.25,
          rotation: -23,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 60.5,
          yPercent: 34,
          rotation: -77,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33,
          yPercent: 53.5,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49,
          yPercent: 69.5,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 69,
          yPercent: 52.5,
          rotation: -25,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 41,
          yPercent: 45.25,
          rotation: 18,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 60.5,
          yPercent: 34,
          rotation: -77,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 34,
          yPercent: 54,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49.25,
          yPercent: 69.5,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 69,
          yPercent: 52.5,
          rotation: -24,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 42,
          yPercent: 45.75,
          rotation: 14,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 66.25,
          yPercent: 69,
          rotation: 72,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 60.5,
          yPercent: 34,
          rotation: -77,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33.5,
          yPercent: 53.5,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49,
          yPercent: 70,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 69,
          yPercent: 52,
          rotation: -24,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 41,
          yPercent: 45.5,
          rotation: 16,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 66,
          yPercent: 68,
          rotation: 72,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 70,
          yPercent: 38.5,
          rotation: -31,
          fontSize: 13,
        },
      ],
    },
  },
  lovemugWhite: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 56.0,
          yPercent: 34,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 54.5,
          rotation: 23,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 56,
          yPercent: 34,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 54,
          rotation: 23,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.75,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 56.0,
          yPercent: 34,
          rotation: -77.4,
          fontSize: 23,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 54,
          rotation: 20,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.25,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 64,
          yPercent: 52.5,
          rotation: -29,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 56.0,
          yPercent: 34,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 30,
          yPercent: 54.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.25,
          yPercent: 70,
          rotation: -63,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 63.5,
          yPercent: 53,
          rotation: -24,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 37,
          yPercent: 46,
          rotation: 17,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 56.0,
          yPercent: 34,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.5,
          yPercent: 70.5,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 64,
          yPercent: 53,
          rotation: -26,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 38,
          yPercent: 46.25,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 61,
          yPercent: 68,
          rotation: 73,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 56,
          yPercent: 34,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 30,
          yPercent: 54.5,
          rotation: 21,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 46,
          yPercent: 70,
          rotation: -58,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 64.5,
          yPercent: 52.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 38,
          yPercent: 46,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 61,
          yPercent: 68,
          rotation: 73,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 65.5,
          yPercent: 38.5,
          rotation: -34,
          fontSize: 13,
        },
      ],
    },
  },
  lovemug: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 54.3,
          yPercent: 34,
          rotation: -78,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 54.3,
          yPercent: 34,
          rotation: -78,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44.0,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 54.0,
          yPercent: 34,
          rotation: -78,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62,
          yPercent: 52.25,
          rotation: -30,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 54.0,
          yPercent: 34,
          rotation: -78,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44.0,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62,
          yPercent: 52.5,
          rotation: -23,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 36,
          yPercent: 46.25,
          rotation: 17,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 54.3,
          yPercent: 34,
          rotation: -78,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62,
          yPercent: 52.5,
          rotation: -25,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 36,
          yPercent: 46.5,
          rotation: 16,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 58.75,
          yPercent: 67,
          rotation: 76,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 54.3,
          yPercent: 34,
          rotation: -78,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.25,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44.0,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 61.5,
          yPercent: 53,
          rotation: -26,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 36,
          yPercent: 46,
          rotation: 14,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 59,
          yPercent: 68,
          rotation: 74,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 63,
          yPercent: 39,
          rotation: -31,
          fontSize: 13,
        },
      ],
    },
  },
  toolsBlack: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 41,
          yPercent: 52.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 64.5,
          right: 38.5,
          yPercent: 52,
          rotation: -4,
          fontSize: 14,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 41,
          yPercent: 51,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 63,
          right: 40.5,
          yPercent: 46,
          rotation: -10,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 62.5,
          right: 37.5,
          yPercent: 55,
          rotation: 8,
          fontSize: 14,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 40.5,
          yPercent: 52.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 59.5,
          right: 36,
          yPercent: 40.5,
          rotation: -28,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 63,
          right: 39,
          yPercent: 51,
          rotation: -3,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 59.5,
          right: 37,
          yPercent: 61.5,
          rotation: 28,
          fontSize: 14,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 41.5,
          yPercent: 52.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 55,
          right: 41,
          yPercent: 36.5,
          rotation: -54,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 63.5,
          right: 37,
          yPercent: 46.5,
          rotation: -11,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 63,
          right: 37,
          yPercent: 55.5,
          rotation: 8,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 56,
          right: 40.5,
          yPercent: 66,
          rotation: 45,
          fontSize: 14,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 42,
          yPercent: 52,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 51,
          right: 46.5,
          yPercent: 35,
          rotation: -73,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 61,
          right: 35.5,
          yPercent: 40.5,
          rotation: -39,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 63.5,
          right: 57.5,
          yPercent: 51.5,
          rotation: 2,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 59,
          right: 37.5,
          yPercent: 61.5,
          rotation: 41,
          fontSize: 15,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 50.5,
          right: 47.5,
          yPercent: 67,
          rotation: 72,
          fontSize: 15,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 41.5,
          yPercent: 52,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 46,
          right: 51,
          yPercent: 34,
          rotation: -87,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 57.5,
          right: 40,
          yPercent: 37.5,
          rotation: -55,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 63.5,
          right: 34.5,
          yPercent: 46.5,
          rotation: -17,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 63,
          right: 36,
          yPercent: 55.5,
          rotation: 8,
          fontSize: 14,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 56.5,
          right: 40,
          yPercent: 64.5,
          rotation: 48,
          fontSize: 15,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 44.5,
          right: 52,
          yPercent: 67.5,
          rotation: 90,
          fontSize: 16,
        },
      ],
    },
  },
  tools: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 36,
          yPercent: 53.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 57.5,
          right: 35,
          yPercent: 52,
          rotation: -5,
          fontSize: 14,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 36,
          yPercent: 51.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 56.5,
          right: 37,
          yPercent: 46,
          rotation: -10,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 56,
          right: 43,
          yPercent: 55.5,
          rotation: 9,
          fontSize: 14,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 35.5,
          yPercent: 53,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 53,
          right: 43,
          yPercent: 41,
          rotation: -30,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 56,
          right: 34,
          yPercent: 51,
          rotation: -4,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 53,
          right: 42.5,
          yPercent: 62,
          rotation: 28,
          fontSize: 14,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 36.5,
          yPercent: 53.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 48.5,
          right: 46,
          yPercent: 36.5,
          rotation: -53,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 56.5,
          right: 38,
          yPercent: 46,
          rotation: -14,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 56.5,
          right: 43,
          yPercent: 56,
          rotation: 7,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 50,
          right: 46,
          yPercent: 66.5,
          rotation: 48,
          fontSize: 14,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 36.5,
          yPercent: 53,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 44.5,
          right: 51,
          yPercent: 35,
          rotation: -76,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 54.5,
          right: 42,
          yPercent: 41,
          rotation: -41,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 56.5,
          right: 37,
          yPercent: 51.5,
          rotation: 0,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 52.5,
          right: 43,
          yPercent: 62,
          rotation: 40,
          fontSize: 14,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 44,
          right: 52,
          yPercent: 68,
          rotation: 72,
          fontSize: 14,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 36.5,
          yPercent: 52.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 39.5,
          right: 55.5,
          yPercent: 33.5,
          rotation: -89,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 46,
          right: 31,
          yPercent: 29.5,
          rotation: -58,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 56.5,
          right: 41,
          yPercent: 47,
          rotation: -19,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 56,
          right: 38,
          yPercent: 56,
          rotation: 7,
          fontSize: 14,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 50,
          right: 45,
          yPercent: 65,
          rotation: 46,
          fontSize: 14,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 38.5,
          right: 56.5,
          yPercent: 68.5,
          rotation: 89,
          fontSize: 14,
        },
      ],
    },
  },
  toolsWhite: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 38,
          yPercent: 53.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 59.5,
          right: 40,
          yPercent: 52.5,
          rotation: -4,
          fontSize: 14,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 37.5,
          yPercent: 52,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 58.5,
          right: 34,
          yPercent: 46,
          rotation: -10,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 58,
          right: 45.5,
          yPercent: 55.5,
          rotation: 10,
          fontSize: 14,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 37.5,
          yPercent: 53.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 55,
          right: 40,
          yPercent: 41,
          rotation: -30,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 58,
          right: 38,
          yPercent: 51.5,
          rotation: -2,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 55,
          right: 41.5,
          yPercent: 62,
          rotation: 28,
          fontSize: 14,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 38,
          yPercent: 53,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 51,
          right: 45,
          yPercent: 37,
          rotation: -54,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 59,
          right: 38,
          yPercent: 46.5,
          rotation: -14,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 58,
          right: 35,
          yPercent: 56.5,
          rotation: 9,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 52,
          right: 44.5,
          yPercent: 66.5,
          rotation: 45,
          fontSize: 14,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 38.5,
          yPercent: 53,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 46,
          right: 49.5,
          yPercent: 35,
          rotation: -75,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 56.5,
          right: 40,
          yPercent: 41,
          rotation: -40,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 58.5,
          right: 36.5,
          yPercent: 52,
          rotation: 2,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 54.5,
          right: 41.5,
          yPercent: 62,
          rotation: 41,
          fontSize: 14,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 46,
          right: 50.5,
          yPercent: 68,
          rotation: 72,
          fontSize: 14,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 38.5,
          yPercent: 52.5,
          rotation: 2,
          fontSize: 18,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 41.5,
          right: 54,
          yPercent: 34,
          rotation: -89,
          fontSize: 14,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 52.5,
          right: 43.5,
          yPercent: 37.5,
          rotation: -60,
          fontSize: 14,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 58.5,
          right: 38.5,
          yPercent: 47,
          rotation: -19,
          fontSize: 14,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 58,
          right: 40,
          yPercent: 56,
          rotation: 10,
          fontSize: 14,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 52.5,
          right: 44,
          yPercent: 65,
          rotation: 47,
          fontSize: 14,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 42,
          right: 56,
          yPercent: 67.5,
          rotation: 90,
          fontSize: 14,
        },
      ],
    },
  },
  soccerBlack: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 57.0,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 31.5,
          yPercent: 50.5,
          rotation: 22,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 57.0,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 31.5,
          yPercent: 50.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.8,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },  
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 57.0,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 31.5,
          yPercent: 50.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.8,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 66.1,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 57.0,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 31.5,
          yPercent: 50.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.8,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 66.1,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 37,
          yPercent: 42.0,
          rotation: 15,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 57.0,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 31.5,
          yPercent: 50.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.8,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 66.1,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 37,
          yPercent: 42.0,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 63.7,
          yPercent: 66,
          rotation: 73,
          fontSize: 13,
        },
        
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 57.0,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 31.5,
          yPercent: 50.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.8,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 66.1,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 37,
          yPercent: 42.0,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 63.7,
          yPercent: 66,
          rotation: 73,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 67.9,
          yPercent: 35.4,
          rotation: -34,
          fontSize: 13,
        },
      ],
    },
  },
  soccer: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 51.6,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 26.1,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 51.6,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 26.1,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 41.0,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 51.6,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 26.1,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 41.0,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 60.9,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 51.6,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 26.1,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 41.0,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 60.9,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 32.6,
          yPercent: 42.7,
          rotation: 15,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 51.6,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 26.1,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 41.0,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 60.9,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 32.6,
          yPercent: 42.7,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 56.9,
          yPercent: 66,
          rotation: 73,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 51.6,
          yPercent: 31,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 26.1,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 41.0,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 60.9,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 32.6,
          yPercent: 42.7,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 56.9,
          yPercent: 66,
          rotation: 73,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 61.6,
          yPercent: 36,
          rotation: -34,
          fontSize: 13,
        },
      ],
    },
  },
  soccerWhite: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.0,
          yPercent: 32,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.0,
          yPercent: 32,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },  
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.0,
          yPercent: 32,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62.5,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.0,
          yPercent: 32,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62.5,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 34,
          yPercent: 42.5,
          rotation: 15,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.0,
          yPercent: 32,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62.5,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 34,
          yPercent: 42.5,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 58.5,
          yPercent: 65,
          rotation: 73,
          fontSize: 13,
        },
        
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.0,
          yPercent: 32,
          rotation: -77.4,
          fontSize: 24,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 51,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43,
          yPercent: 67,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62.5,
          yPercent: 49.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 34,
          yPercent: 42.5,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 58.5,
          yPercent: 65,
          rotation: 73,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 64.5,
          yPercent: 35,
          rotation: -34,
          fontSize: 13,
        },
      ],
    },
  },
  toolmugBlack: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 59.25,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33,
          yPercent: 54.0,
          rotation: 25,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 59.1,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33.5,
          yPercent: 53.8,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 48.5,
          yPercent: 68.5,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 59.8,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 34,
          yPercent: 53.8,
          rotation: 25,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49.25,
          yPercent: 69,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 68.5,
          yPercent: 52.25,
          rotation: -23,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 59.8,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33,
          yPercent: 53.8,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49,
          yPercent: 69.5,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 69,
          yPercent: 52.4,
          rotation: -25,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 41,
          yPercent: 45.25,
          rotation: 18,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 59.5,
          yPercent: 36,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33.55,
          yPercent: 54.2,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 48.2,
          yPercent: 69.5,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 69,
          yPercent: 52.3,
          rotation: -24,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 41.7,
          yPercent: 45.75,
          rotation: 14,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 65.4,
          yPercent: 69,
          rotation: 72,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 59.8,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 33.5,
          yPercent: 54.0,
          rotation: 24,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 49.3,
          yPercent: 69.55,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 69,
          yPercent: 52.2,
          rotation: -24,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 41,
          yPercent: 45.5,
          rotation: 16,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 65.9,
          yPercent: 68,
          rotation: 72,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 70,
          yPercent: 38.5,
          rotation: -31,
          fontSize: 13,
        },
      ],
    },
  },
  toolmugWhite: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 55.25,
          yPercent: 37,
          rotation: -77.1,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 55.0,
          rotation: 23,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 55.15,
          yPercent: 37,
          rotation: -77.1,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 54.7,
          rotation: 23,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44.75,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 55.40,
          yPercent: 37,
          rotation: -77.1,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.6,
          yPercent: 54.5,
          rotation: 20,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.25,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 64,
          yPercent: 52.5,
          rotation: -29,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 55.45,
          yPercent: 37,
          rotation: -77.1,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 30,
          yPercent: 55.0,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 45.25,
          yPercent: 70,
          rotation: -63,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 63.5,
          yPercent: 53,
          rotation: -24,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 37,
          yPercent: 46,
          rotation: 17,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 55.25,
          yPercent: 37,
          rotation: -77.1,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 29.5,
          yPercent: 55.0,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44.25,
          yPercent: 70.5,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 64,
          yPercent: 53,
          rotation: -26,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 38,
          yPercent: 46.4,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 60.25,
          yPercent: 68,
          rotation: 73,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 55.5,
          yPercent: 37,
          rotation: -77.1,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 30,
          yPercent: 55.0,
          rotation: 21,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 46,
          yPercent: 69.4,
          rotation: -58,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 64.5,
          yPercent: 52.5,
          rotation: -28,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 38,
          yPercent: 46.4,
          rotation: 15,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 60.8,
          yPercent: 67.8,
          rotation: 73,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 65.5,
          yPercent: 38.5,
          rotation: -34,
          fontSize: 13,
        },
      ],
    },
  },
  toolmug: {
    1: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.2,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 27.5,
          yPercent: 54.8,
          rotation: 22,
          fontSize: 13,
        },
      ],
    },
    2: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.1,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 28,
          yPercent: 54.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 42.8,
          yPercent: 69.7,
          rotation: -60,
          fontSize: 13,
        },
      ],
    },
    3: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.2,
          yPercent: 38,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 28,
          yPercent: 54.2,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 44,
          yPercent: 69,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62,
          yPercent: 52.4,
          rotation: -30,
          fontSize: 13,
        },
      ],
    },
    4: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.75,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 28,
          yPercent: 54.85,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43.25,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 62,
          yPercent: 52.6,
          rotation: -23,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 36,
          yPercent: 46.25,
          rotation: 17,
          fontSize: 13,
        },
      ],
    },
    5: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.5,
          yPercent: 36,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 28,
          yPercent: 54.6,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 42.75,
          yPercent: 70,
          rotation: -59,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 61.7,
          yPercent: 52.6,
          rotation: -25,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 36,
          yPercent: 46.5,
          rotation: 16,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 58.2,
          yPercent: 68.7,
          rotation: 76,
          fontSize: 13,
        },
      ],
    },
    6: {
      textFields: [
        {
          id: "text1",
          content: "",
          xPercent: 53.75,
          yPercent: 37,
          rotation: -77,
          fontSize: 22,
        },
        {
          id: "text2",
          content: "Noah",
          xPercent: 28.0,
          yPercent: 54.5,
          rotation: 22,
          fontSize: 13,
        },
        {
          id: "text3",
          content: "Vera",
          xPercent: 43.5,
          yPercent: 70,
          rotation: -60,
          fontSize: 13,
        },
        {
          id: "text4",
          content: "Hugo",
          xPercent: 61.5,
          yPercent: 53,
          rotation: -26,
          fontSize: 13,
        },
        {
          id: "text5",
          content: "Alma",
          xPercent: 36,
          yPercent: 46.4,
          rotation: 14,
          fontSize: 13,
        },
        {
          id: "text6",
          content: "Liam",
          xPercent: 58.9,
          yPercent: 68.6,
          rotation: 74,
          fontSize: 13,
        },
        {
          id: "text7",
          content: "Alice",
          xPercent: 63,
          yPercent: 39,
          rotation: -31,
          fontSize: 13,
        },
      ],
    },
  },
};


// Add this configuration section at the top of your script
const apiConfig = {
  uploadEndpoint:"https://morsdag-general.onrender.com/api/generate-images",
  // uploadEndpoint:"https://cuddly-space-system-4jr65g77v95rf76q4-5000.app.github.dev/api/generate-images",
  requestTimeout: 30000, //Timeout for API requests in milliseconds
};

// Add this global constant at the beginning of the script
const MAX_PERSONALIZATION_CHARS = 10;

document.addEventListener("DOMContentLoaded", init);

function init() {
  // -- COMMON ELEMENTS & INITIALIZATION --
  const personalizationContainer = document.querySelector(
    ".product-personalization"
  );
  const productForm = document.querySelector('form[method="post"][data-type="add-to-cart-form"]');
  const sectionId = personalizationContainer.dataset.sectionId;
  const shopifyButton = document.getElementById(
    `ProductSubmitButton-${sectionId}`
  );
  const ProductFormButton = document.querySelector(".product-form__buttons");
  const product = document.querySelector("product-info");
  const personalizationFields = document.getElementById(
    "personalization-fields"
  );
  const inputsContainer = document.getElementById(
    "personalization-inputs-container"
  );
  const galleryWrapper = document.querySelector(
    ".product-gallery__media-wrapper"
  );
  const customizerWrapper = document.querySelector(
    ".product-customizer__media-wrapper"
  );
  const customizerImage = document.querySelector(
    "#productCustomizer .base-image"
  );
  const canvas = document.querySelector("#productCustomizer canvas");
  const productTitle = document.querySelector("product-info").dataset.productTitle.replace(/\s+/g, '');
  
  // Early exit if critical elements are missing
  if (!productForm || !personalizationContainer || !ProductFormButton  ) return;

  // Show the personalizer on first load
  showPersonalizer();

  // -- PERSONALIZATION DATA INITIALIZATION --
  personalizationContainer.dataset.numberOfKids = getInitialNumberOfKids();
  personalizationContainer.dataset.selectedColor = getSelectedColor();

  // Store initial image data if customizer exists
  let defaultSrc, defaultSrcset;
  if (customizerImage) {
    defaultSrc = customizerImage.src;
    defaultSrcset = customizerImage.srcset;
  }

  // Load variant data from JSON
  let variantData = {};
  const variantJson = document.querySelector('[id^="VariantJSON-"]');
  if (variantJson) {
    try {
      variantData = JSON.parse(variantJson.textContent);
    } catch (e) {
      console.error("Error parsing variant JSON:", e);
    }
  }

  // Function to get initial number of kids from product options at page load
  function getInitialNumberOfKids() {
    const variantScript = document.querySelector(
      "script[data-selected-variant]"
    );
    if (!variantScript) return 1;

    let variantData;
    try {
      variantData = JSON.parse(variantScript.textContent.trim());
    } catch (e) {
      console.error("Error parsing variant JSON:", e);
      return;
    }

    const numberOfKidsOption = variantData.option2; // e.g., "6 Kids"
    const match = numberOfKidsOption.match(/(\d+)/);
    return parseInt(match[1], 10);
  }

  // Function to get the selected color
  function getSelectedColor() {
    const variantScript = document.querySelector(
      "script[data-selected-variant]"
    );
    if (!variantScript) return "Ceramic Yellow";

    let variantData;
    try {
      variantData = JSON.parse(variantScript.textContent.trim());
    } catch (e) {
      console.error("Error parsing variant JSON:", e);
      return;
    }
    const selectedColor = variantData.option1.split(" ").at(-1); // e.g., "Keramisk, gul"
    return translateToEnglish(selectedColor);
  }

function translateToEnglish(word) {
  const translations = {
    // Svenska
    vit: 'white',
    gul: 'yellow',
    rosa: 'pink',
    grön: 'green',
    röd: 'red',
    svart: 'black',
    blå: 'blue',

    // Norska
    hvit: 'white',
    grøn: 'green',
    grønn: 'green',
    rød: 'red',
    rod: 'red',
    svart: 'black',
    sort: 'black',
    blå: 'blue',
    bla: 'blue',

    // Spanska
blanco: 'white',
amarillo: 'yellow',
amarilla: 'yellow',
rosa: 'pink',
verde: 'green',
rojo: 'red',
roja: 'red',
negro: 'black',
negra: 'black',
azul: 'blue',

    // Tyska
weiß: 'white',
weiss: 'white',
gelb: 'yellow',
rosa: 'pink',
grün: 'green',
gruen: 'green',
rot: 'red',
schwarz: 'black',
blau: 'blue',

    // Danska
    hvid: 'white',

    // Finska
    valkoinen: 'white',
    keltainen: 'yellow',
    vaaleanpunainen: 'pink',
    vihreä: 'green',
    punainen: 'red',
    musta: 'black',
    sininen: 'blue',

    // Franska
    blanc: 'white',
blanche: 'white',
jaune: 'yellow',
rose: 'pink',
vert: 'green',
verte: 'green',
rouge: 'red',
noir: 'black',
noire: 'black',
bleu: 'blue',
bleue: 'blue',
  };

  word = (word || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[.,]/g, '');

  if (translations[word]) {
    return translations[word];
  }

  // Om det redan är engelska
  if (Object.values(translations).includes(word)) {
    return word;
  }

  // ✅ ALLTID lowercase fallback
  return 'white';
}

  // Function to find matching variant data
  function getVariantData(variantId) {
    if (!variantData.variants) return null;
    return variantData.variants.find((v) => v.id == variantId);
  }

  // Function to get the current template based on number of kids
  function getCurrentTemplate() {
    const numberOfKids = personalizationContainer.dataset.numberOfKids
      ? parseInt(personalizationContainer.dataset.numberOfKids, 10)
      : getInitialNumberOfKids();

    const currentColor = (getSelectedColor() || '').toLowerCase();

    const templateKey = currentColor === "white"
    ? `${productTitle.toLowerCase()}White`
    : currentColor === "black"
    ? `${productTitle.toLowerCase()}Black`
    : productTitle.toLowerCase();
    
    const templateSet = defaultTemplates[templateKey];

    if (!templateSet) {
      console.error("Template not found for key:", templateKey);
      return null;
    }

    return templateSet[numberOfKids];
  }

  // -- PERSONALIZATION FIELD FUNCTIONS --
  // Also update updatePersonalizationData to respect the character limit
  function updatePersonalizationData() {
    const personalizationData = {
      kids: [],
      color: getSelectedColor() || "Ceramic Yellow",
    };

    const inputs = document.querySelectorAll(".personalization-input");
    inputs.forEach((input) => {
      // Ensure value doesn't exceed max length
      const value = input.value.substring(0, MAX_PERSONALIZATION_CHARS);

      personalizationData.kids.push({
        index: parseInt(input.getAttribute("data-kid-index"), 10) + 1,
        textId: input.getAttribute("data-text-id"),
        name: value,
      });
    });

    let hiddenInput = document.getElementById("personalization-data");
    if (!hiddenInput) {
      hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.id = "personalization-data";
      hiddenInput.name = "properties[Personalization]";
      if (productForm) {
        productForm.appendChild(hiddenInput);
      }
    }

    hiddenInput.value = JSON.stringify(personalizationData);
  }

  // -- IMAGE CUSTOMIZER FUNCTIONS --
  // Function to update customizer image when variant changes
  function updateCustomizerImage(variantId) {
    if (!customizerImage) return;

    // Store current input values before updating
    const currentValues = {};
    const inputs = document.querySelectorAll(".personalization-input");
    inputs.forEach((input) => {
      const textId = input.getAttribute("data-text-id");
      currentValues[textId] = input.value;
    });

    // Method 1: Try to find from variant data
    const variant = getVariantData(variantId);
    if (variant && variant.featured_image) {
      customizerImage.src = variant.featured_image;
      // Clear srcset as we're using a direct URL
      customizerImage.removeAttribute("srcset");
      return;
    }

    // Method 2: Try to find from gallery images
    if (variant && variant.featured_media_id) {
      const mediaId = variant.featured_media_id;
      const galleryImage = document.querySelector(
        `[data-media-id="${mediaId}"] img`
      );
      if (galleryImage) {
        customizerImage.src = galleryImage.src;
        if (galleryImage.srcset) {
          customizerImage.srcset = galleryImage.srcset;
        }
        return;
      }
    }

    // Method 3: Try to find from the gallery viewer
    const selectedSlide = document.querySelector(
      ".product__media-item.is-active img"
    );
    if (selectedSlide) {
      customizerImage.src = selectedSlide.src;
      if (selectedSlide.srcset) {
        customizerImage.srcset = selectedSlide.srcset;
      }
      return;
    }

    // If no match was found, revert to default
    customizerImage.src = defaultSrc;
    customizerImage.srcset = defaultSrcset;
  }

  // Function to dynamically adjust font size based on character length, starting from the template's fontSize
  function adjustFontSize(overlay, baseFontSize) {
    const charCount = overlay.textContent.trim().length;
    const maxChars = MAX_PERSONALIZATION_CHARS; // Assuming this is 10
    
    // Check if device is mobile
    const isMobile = window.innerWidth <= 768; // Common mobile breakpoint
    
    // Different scaling factors for mobile and desktop
    const minScaleFactor = isMobile ? 0.4 : 0.6; // Smaller scale for mobile
    
    // Linearly scale down from 100% (baseFontSize) to minScaleFactor as char count goes from 1 to maxChars
    const scaleFactor =
      1 - ((charCount - 1) / (maxChars - 1)) * (1 - minScaleFactor);
    const adjustedFontSize = baseFontSize * scaleFactor;

    // Ensure the font size doesn't go below the minimum scale
    const size = Math.max(adjustedFontSize, baseFontSize * minScaleFactor);
    overlay.style.fontSize = `${size}px`
  }

  function generateInputFields() {
    if (!inputsContainer) return;

    // Retrieve translations from dataset
    const personalizationContainer = document.querySelector(
      ".product-personalization"
    );
    if (!personalizationContainer) return;

    const translations = {
      labelGrandpa: personalizationContainer.dataset.labelGrandpa,
      labelKid: personalizationContainer.dataset.labelKid,
      placeholder: personalizationContainer.dataset.placeholder,
      ordinals: JSON.parse(personalizationContainer.dataset.ordinals || "{}"),
    };

    // Store current input values before clearing
    const currentValues = {};
    const existingInputs = document.querySelectorAll(".personalization-input");
    existingInputs.forEach((input) => {
      const textId = input.getAttribute("data-text-id");
      currentValues[textId] = input.value;
    });

    // Clear existing inputs
    inputsContainer.innerHTML = "";

    // Remove any previous error message
    const existingErrorMsg = document.querySelector(
      ".personalization-char-limit-error"
    );
    if (existingErrorMsg) existingErrorMsg.remove();

    const template = getCurrentTemplate()    

    // Loop through all fields in the template, including the first one
    for (let i = 0; i < template.textFields.length; i++) {
      const textField = template.textFields[i];

      // Create field container with Shopify styling
      const fieldContainer = document.createElement("div");
      fieldContainer.className = "personalization-field";

      // Create label with Shopify styling
      const label = document.createElement("label");
      label.className = "personlaization-form__label";
      label.setAttribute("for", `personalization-input-${i}`);

      if (i === 0) {
        label.textContent = translations.labelGrandpa;
      } else {
        const ordinalKey =
          ["first", "second", "third", "fourth", "fifth", "sixth"][i - 1] ||
          `${i + 1}th`;
        const ordinal = translations.ordinals[ordinalKey] || `${i + 1}th`;
        label.textContent = translations.labelKid.replace(
          "%{ordinal}",
          ordinal
        );
      }

      // Create input with Shopify styling
      const input = document.createElement("input");
      input.type = "text";
      input.id = `personalization-input-${i}`;
      input.className = "personalization-field__input personalization-input";
      input.setAttribute("data-kid-index", i);
      input.setAttribute("data-text-id", textField.id);
      input.setAttribute("placeholder", translations.placeholder);
      input.setAttribute("maxlength", MAX_PERSONALIZATION_CHARS);

      // Use saved value if exists, otherwise use template content
      input.value =
        currentValues[textField.id] !== undefined
          ? currentValues[textField.id]
          : textField.content;

      // Truncate if value is longer than max allowed
      if (input.value.length > MAX_PERSONALIZATION_CHARS) {
        input.value = input.value.substring(0, MAX_PERSONALIZATION_CHARS);
      }

      input.addEventListener("input", function (e) {        
        if (document.querySelector(".personalization-message")) {
          hideMessage();
        }
        
        // Check if input exceeds character limit
        if (e.target.value.length === MAX_PERSONALIZATION_CHARS) {
          e.target.value = e.target.value.substring(
            0,
            MAX_PERSONALIZATION_CHARS
          );
          showCharLimitError();
        } else {
          // If within limits, hide error message if it exists
          hideCharLimitError();
        }

        updatePersonalizationData();
        const overlay = document.getElementById(`overlay-${textField.id}`);
        if (overlay) {
          overlay.textContent = e.target.value;
        }

        // Get the base font size from the template for this field
        let baseFontSize;
        const template = getCurrentTemplate();
        const field = template.textFields.find((f) => f.id === textField.id);
        const fontSize = field && field.fontSize ? parseFloat(field.fontSize) : 10;
        const isMobile = window.innerWidth <= 768; // adjust breakpoint if needed
        
        if (productTitle === "lovemug" || productTitle === "toolmug" || productTitle === "soccer") {
          baseFontSize =  isMobile ? fontSize * 0.6 : fontSize; // 30% reduction on mobile
        } else {
          baseFontSize = field && field.fontSize ? parseFloat(field.fontSize) : 10;
          adjustFontSize(overlay, baseFontSize);
        }
        
        overlay.style.fontSize = `{baseFontSize}px`;
      });

      fieldContainer.appendChild(label);
      fieldContainer.appendChild(input);
      inputsContainer.appendChild(fieldContainer);
    }

    // Update data after generating fields
    updatePersonalizationData();
  }

  // Add these new functions for handling the character limit error message
  function showCharLimitError() {
    if (!personalizationContainer) return;

    const charLimitErrorTemplate =
      personalizationContainer.dataset.charLimitError ||
      "Maximum %{max_chars} characters allowed.";
    const errorMessage = charLimitErrorTemplate.replace(
      "%{max_chars}",
      MAX_PERSONALIZATION_CHARS
    );

    // Only create error message if it doesn't exist
    if (!document.querySelector(".personalization-char-limit-error")) {
      const errorMsg = document.createElement("div");
      errorMsg.className = "personalization-char-limit-error";
      errorMsg.textContent = errorMessage;
      errorMsg.style.color = "#cc0000";
      errorMsg.style.fontSize = "1.8rem";
      errorMsg.style.marginTop = "5px";

      // Append to the bottom of input container
      inputsContainer.appendChild(errorMsg);
    }
  }

  function hideCharLimitError() {
    // Check if any input is currently over the limit
    const inputs = document.querySelectorAll(".personalization-input");
    const anyOverLimit = Array.from(inputs).some(
      (input) => input.value.length > MAX_PERSONALIZATION_CHARS
    );

    // Only remove error message if no inputs are over the limit
    if (!anyOverLimit) {
      const errorMsg = document.querySelector(
        ".personalization-char-limit-error"
      );
      if (errorMsg) errorMsg.remove();
    }
  }

  function applyTextOverlays() {
    const template = getCurrentTemplate();
    if (!template || !template.textFields) return;
    const imageContainer = document.querySelector("#productCustomizer");
    if (!imageContainer) return;

    const imageWrapper = imageContainer.querySelector(".image-wrapper");
    if (!imageWrapper) return;

    const existingValues = {};
    const existingOverlays = imageWrapper.querySelectorAll(".text-overlay");
    existingOverlays.forEach((overlay) => {
      const id = overlay.id.replace("overlay-", "");
      existingValues[id] = overlay.textContent;
      overlay.remove();
    });

    const inputs = document.querySelectorAll(".personalization-input");
    const inputsMap = {};
    inputs.forEach((input) => {
      const textId = input.getAttribute("data-text-id");
      inputsMap[textId] = input.value;
    });

    template.textFields.forEach((field) => {
      const textElement = document.createElement("div");
      textElement.id = `overlay-${field.id}`;
      textElement.setAttribute("translate", "no"); // Prevent translation of placeholder and value

      let text = existingValues[field.id];
      if (text === undefined) {
        text = inputsMap[field.id] || field.content;
      }
      const numberOfKids =
        parseInt(personalizationContainer.dataset.numberOfKids, 10) || 1;
      const currentColor = getSelectedColor().toLowerCase();

      const color =
        currentColor === "white" || currentColor === "black" ? currentColor : "colored";

      textElement.className = productTitle === "lovemug" || productTitle === "toolmug" || productTitle === "soccer"
    ? "text-overlay lovemug-overlay" : "text-overlay";

      textElement.textContent = text;
      textElement.dataset.rotation = field.rotation;
      textElement.style.opacity = "0";
      textElement.style.transition = "opacity 0.3s ease-in-out";

      imageWrapper.appendChild(textElement);
    });

    positionTextElements();

    setTimeout(() => {
      const textOverlays = imageWrapper.querySelectorAll(".text-overlay");
      textOverlays.forEach((overlay) => {
        overlay.style.opacity = "1";
      });
    }, 50);
  }

  function positionTextElements() {
    const containerWidth =
      imageContainer.querySelector(".image-wrapper").offsetWidth;
    const containerHeight = baseImage.offsetHeight;
    const currentTemplate = getCurrentTemplate();

    if (productTitle === "lovemug" || productTitle === "toolmug" || productTitle === "soccer") {
      currentTemplate.textFields.forEach((field) => {
        const textElement = document.getElementById(`overlay-${field.id}`);
        if (!textElement) return;
        
        textElement.style.left = `${field.xPercent}%`;
        textElement.style.top = `${field.yPercent}%`;      
        textElement.style.textAlign = "center";
        textElement.style.transform = `translateX(-50%) rotate(${field.rotation}deg)`;
        
        const fontSize = field && field.fontSize ? parseFloat(field.fontSize) : 10;
        const isMobile = window.innerWidth <= 768; // adjust breakpoint if needed
        // Re-adjust font size using the base font size from the template
        const baseFontSize =  isMobile ? fontSize * 0.6 : fontSize; // 30% reduction on mobile        
        textElement.style.fontSize = `${baseFontSize}px`;
      });
    } else {
      currentTemplate.textFields.forEach((field) => {
        const textElement = document.getElementById(`overlay-${field.id}`);
        if (!textElement) return;

        const xPos = (field.xPercent / 100) * containerWidth;
        const yPos = (field.yPercent / 100) * containerHeight;
        textElement.style.left = `${xPos}px`;
        textElement.style.top = `${yPos}px`;
        if (field.id === "text1") {
          textElement.style.transform = `translate(-100%, -50%) rotate(${
            textElement.dataset.rotation || field.rotation
          }deg)`;
        } else {
          textElement.style.transform = `translate(0, -50%) rotate(${
            textElement.dataset.rotation || field.rotation
          }deg)`;
          textElement.style.right = `${field.right}%`
        }

        // Re-adjust font size using the base font size from the template
        const baseFontSize = field.fontSize ? parseFloat(field.fontSize) : 10;        
        adjustFontSize(textElement, baseFontSize);
      });
    }
  }

  // Add this function to maintain the state after variant change
  function preservePersonalizationState() {
    // Store current values from overlays
    const overlayValues = {};
    const overlays = document.querySelectorAll(".text-overlay");
    overlays.forEach((overlay) => {
      const id = overlay.id.replace("overlay-", "");
      overlayValues[id] = overlay.textContent;
    });

    // Update inputs with these values
    const inputs = document.querySelectorAll(".personalization-input");
    inputs.forEach((input) => {
      const textId = input.getAttribute("data-text-id");
      if (overlayValues[textId] !== undefined) {
        input.value = overlayValues[textId];
      }
    });

    updatePersonalizationData();
  }

  // Update the canvas with the current image and personalization
  function updateCanvas() {
    if (!canvas && !customizerImage) return;
    const canvasElement = canvas ? canvas : customizerImage;
    const ctx = canvasElement.getContext("2d");
    const img = new Image();

    img.onload = function () {
      canvasElement.width = img.width;
      canvasElement.height = img.height;
      ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
      ctx.drawImage(img, 0, 0);

      // Apply text overlays based on personalization inputs and template
      applyTextOverlays();
    };

    img.src = customizerImage.src;
  }

  function hideProductFormButtons() {
    if (ProductFormButton) {
      ProductFormButton.style.display = "none";
    }
  }

  function triggerShopifyAddToCart() {
    if (shopifyButton) {
      shopifyButton.click();
      document.dispatchEvent(new CustomEvent('cart:requestComplete', { detail: { } }));
    }
  }

  function showMessage(message, type = "error") {
    hideMessage();

    const Container = document.createElement("div");
    Container.className = `personalization-message personalization-message--${type}`;

    const icon = document.createElement("span");
    icon.className = "personalization-message__icon";
    icon.textContent = type === "error" ? "⚠️" : "ℹ️";

    const messageText = document.createElement("span");
    messageText.className = "personalization-message__text";
    messageText.textContent = message;

    Container.appendChild(icon);
    Container.appendChild(messageText);

    const insertLocation =
      personalizationFields ||
      document.querySelector(".personalization-button-container") ||
      document.querySelector(".product-form");

    if (insertLocation) {
      insertLocation.parentNode.insertBefore(Container, insertLocation);
    }

    if (type !== "error") {
      setTimeout(hideErrorMessage, 5000);
    }
  }

  function hideMessage() {
    const existingMessage = document.querySelector(".personalization-message");
    if (existingMessage) {
      existingMessage.remove();
    }
  }

  // Updated function to save personalization, send data to backend, and add to cart
  async function saveAndAddToCart() {
    // Collect design configuration and image source
    const imageWrapper = document.querySelector(
      "#productCustomizer .image-wrapper"
    );
    const imageElement = imageWrapper.querySelector("img");
    const imageSrc = imageElement ? imageElement.src : null;
    const loading = document.querySelector(".loading-indicator");

    if (!imageSrc) {
      console.error("No image source found in .image-wrapper");
      showMessage("No image found for preview generation.");
      if (loading) loading.style.display = "none";
      return;
    }

    validateData(imageSrc)

    // Show loading indicator if exists
    if (loading) loading.style.display = "flex";

    personalizationFields.style.display = "none";

    try {
      // Send personalization data to backend (handles its own errors)
      const data = await sendPersonalizationDataAndAddToCart(imageSrc);

      // Success handling
      if (data && data.success && data.personalizationId) {
        // Store the personalization ID in the form (handles its own errors)
        setProductPersonalizationId(data.personalizationId);

        // Add to cart
        triggerShopifyAddToCart();
      } else {
        console.error(
          "Invalid response format, missing personalization_id",
          data
        );
        showMessage("Error saving personalization. Please try again.");
        personalizationFields.style.display = "block";
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error during personalization save:", error);
      // Only show message if the called functions didn't already handle it
      if (!error.handled) {
        showMessage("Error saving personalization. Please try again.");
      }
      personalizationFields.style.display = "block";
    } finally {
      // Hide loading indicator
      const loading = document.querySelector(".loading-indicator");
      if (loading) loading.style.display = "none";
      // Hide customizer
      customizerWrapper.classList.add("hidden");
      galleryWrapper.classList.remove("hidden");
    }
  }

  function validateData (imageSrc)  {
    // Get required data
    const selectedColor = getSelectedColor() || "Ceramic Yellow";
    const numberOfKids =
      parseInt(personalizationContainer.dataset.numberOfKids, 10) || 1;
    const personalizationData = document.getElementById(
      "personalization-data"
    ).value;

    // Validate inputs
    if (!imageSrc || imageSrc.trim() === "") {
      showMessage("Image source is missing. Please try again.");
      const error = new Error("Image source is required");
      error.handled = true;
      throw error;
    }

    if (!selectedColor || selectedColor.trim() === "") {
      showMessage("Please select a color before proceeding.");
      const error = new Error("Color selection is required");
      error.handled = true;
      throw error;
    }

    if (!numberOfKids || numberOfKids < 1) {
      showMessage("Number of kids must be at least 1.");
      const error = new Error("Invalid number of kids");
      error.handled = true;
      throw error;
    }

    if (!personalizationData || personalizationData.trim() === "") {
      showMessage(
        "Please fill in all personalization fields before proceeding."
      );
      const error = new Error("Personalization data is required");
      error.handled = true;
      throw error;
    }

    // Validate personalization data structure
    let parsedPersonalizationData;
    try {
      parsedPersonalizationData = JSON.parse(personalizationData);
    } catch (parseError) {
      showMessage("Invalid personalization data format. Please try again.");
      const error = new Error("Invalid personalization data format");
      error.handled = true;
      throw error;
    }

    // Validate that all kids have names filled
    if (
      parsedPersonalizationData.kids &&
      Array.isArray(parsedPersonalizationData.kids)
    ) {
      const emptyNames = parsedPersonalizationData.kids.filter(
        (kid) => !kid.name || kid.name.trim() === ""
      );

      if (emptyNames.length > 0) {
        showMessage("Please fill in all children's names before proceeding.");
        const error = new Error("All children names are required");
        error.handled = true;
        throw error;
      }

      // Validate that we have the expected number of kids
      if (
        Number(parsedPersonalizationData.kids.length) - 1 !==
        numberOfKids
      ) {
        showMessage(`Please provide names for all ${numberOfKids} children.`);
        const error = new Error("Mismatch in number of kids");
        error.handled = true;
        throw error;
      }
    } else {
      showMessage(
        "Invalid personalization data structure. Please try again."
      );
      const error = new Error("Invalid personalization data structure");
      error.handled = true;
      throw error;
    }
  }

  // Updated function to send personalization data to backend with validation and error handling
  async function sendPersonalizationDataAndAddToCart(imageSrc) {
    try {
      // Get required data
      const selectedColor = getSelectedColor() || "Ceramic Yellow";
      const numberOfKids =
        parseInt(personalizationContainer.dataset.numberOfKids, 10) || 1;
      const personalizationData = document.getElementById(
        "personalization-data"
      ).value;     

      // Build design configuration
      const designConfig = {
        imageSrc,
        color: selectedColor,
        number_of_kids: numberOfKids,
        product_title: productTitle,
        personalization_data: personalizationData,
      };

      // Send data to backend using fetch
      const response = await fetch(apiConfig.uploadEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(designConfig),
        timeout: apiConfig.requestTimeout,
      });

      if (!response.ok) {
        let errorMessage = "Server error occurred. Please try again.";

        // Handle specific HTTP status codes
        switch (response.status) {
          case 400:
            errorMessage =
              "Invalid data sent to server. Please check your inputs.";
            break;
          case 401:
            errorMessage = "Authentication required. Please refresh the page.";
            break;
          case 403:
            errorMessage = "Access denied. Please contact support.";
            break;
          case 404:
            errorMessage = "Service not found. Please contact support.";
            break;
          case 500:
            errorMessage = "Server error. Please try again later.";
            break;
          default:
            errorMessage = `Server error (${response.status}). Please try again.`;
        }

        showMessage(errorMessage);
        const error = new Error(
          `Server returned ${response.status}: ${response.statusText}`
        );
        error.handled = true;
        throw error;
      }

      const responseData = await response.json();

      // Validate response data
      if (!responseData) {
        showMessage("Invalid response from server. Please try again.");
        const error = new Error("Empty response from server");
        error.handled = true;
        throw error;
      }

      return responseData;
    } catch (error) {
      // If error wasn't already handled, mark it as handled and show generic message
      if (!error.handled) {
        console.error(
          "Unexpected error in sendPersonalizationDataAndAddToCart:",
          error
        );
        showMessage("An unexpected error occurred. Please try again.");
        error.handled = true;
      }
      throw error;
    }
  }

  // Updated function to set personalization ID with error handling
  function setProductPersonalizationId(id) {
    try {
      // Validate input
      if (!id || (typeof id !== "string" && typeof id !== "number")) {
        showMessage("Invalid personalization ID received from server.");
        const error = new Error("Invalid personalization ID");
        error.handled = true;
        throw error;
      }

      if (!productForm) {
        showMessage("Product form not found. Please refresh the page.");
        const error = new Error("Product form not found");
        error.handled = true;
        throw error;
      }

      // Set personalization ID
      let personalizationIdInput = productForm.querySelector(
        'input[name="properties[_personalization_Id]"]'
      );

      if (!personalizationIdInput) {
        personalizationIdInput = document.createElement("input");
        personalizationIdInput.type = "hidden";
        personalizationIdInput.name = "properties[_personalization_Id]";
        productForm.appendChild(personalizationIdInput);
      }

      personalizationIdInput.value = String(id);

      // Verify the value was set correctly
      if (personalizationIdInput.value !== String(id)) {
        showMessage("Failed to save personalization data. Please try again.");
        const error = new Error("Failed to set personalization ID");
        error.handled = true;
        throw error;
      }
    } catch (error) {
      // If error wasn't already handled, mark it as handled and show generic message
      if (!error.handled) {
        console.error(
          "Unexpected error in setProductPersonalizationId:",
          error
        );
        showMessage("Failed to save personalization data. Please try again.");
        error.handled = true;
      }
      throw error;
    }
  }

  // -- EVENT LISTENERS --

  // Add image load event listener to ensure canvas updates after image loads
  if (customizerImage) {
    customizerImage.addEventListener("load", function () {
      updateCanvas();
    });
  }
  // Hide/show personalization fields when button is clicked
  function showPersonalizer() {
    // Retrieve translations from dataset
    const personalizationContainer = document.querySelector(
      ".product-personalization"
    );
    if (!personalizationContainer) return;

    const translations = {
      addToCart: personalizationContainer.dataset.addToCart,
      cancel: personalizationContainer.dataset.cancel,
    };

    // Show customizer, hide gallery (same as original hide functionality)
    customizerWrapper.classList.remove("hidden");
    galleryWrapper.classList.add("hidden");
    personalizationFields.style.display = "block";

    const prevBtnContainer = document.querySelector(
      ".personalization-button-container"
    );
    if (prevBtnContainer) {
      prevBtnContainer.remove();
    }

    // When showing personalization fields, replace the single button with two buttons
    hideProductFormButtons();

    // Create button container
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "personalization-button-container";
    buttonContainer.style.display = "flex";
    buttonContainer.style.gap = "10px";
    buttonContainer.style.marginTop = "1rem";
    buttonContainer.style.marginBottom = "1rem";

    // Create Cancel button
    const cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.className = "button button--secondary";
    cancelButton.style.flex = "1";
    cancelButton.textContent = translations.cancel;
    cancelButton.id = "cancel-personalization-button";

    // Create Add to Cart button instead of Save button
    const addToCartButton = document.createElement("button");
    addToCartButton.type = "button";
    addToCartButton.className = "button button--primary";
    addToCartButton.style.flex = "1";
    addToCartButton.textContent = translations.addToCart;
    addToCartButton.id = "personalization-add-to-cart-button";

    // Add buttons to container
    buttonContainer.appendChild(addToCartButton);
    buttonContainer.appendChild(cancelButton);
    
    // Add event listener for Cancel button
    cancelButton.addEventListener("click", function () {
      // Hide customizer, show gallery (same as original hide functionality)
      customizerWrapper.classList.add("hidden");
      galleryWrapper.classList.remove("hidden");
      personalizationFields.style.display = "none";

      // Remove the button container
      buttonContainer.remove();
    });

    // Add event listener for Add to Cart button
    addToCartButton.addEventListener("click", function () {
      // First save personalization with fetch
      saveAndAddToCart();
    });
    
    // Generate inputs if not already generated
    positionTextElements();
    generateInputFields();
        
    // Add container after the personalization fields
    personalizationFields.appendChild(buttonContainer);
    
    // Set up window resize event listener
    window.addEventListener("resize", debounce(positionTextElements, 100));
  }

  // Variant change listeners
  if (productForm) {
    // 1. Listen for variant selectors change
    const variantSelectors = productForm.querySelectorAll(
      '[name^="options"], select[name="id"]'
    );
    variantSelectors.forEach((selector) => {
      selector.addEventListener("change", function () {
        setTimeout(() => {
          const variantId = productForm.querySelector('[name="id"]').value;
          updateCustomizerImage(variantId);

          // If "Number of Kids" changed, we need to update fields
          if (selector.name && selector.name.includes("Number of Kids")) {
            const match = selector.value.match(/(\d+)/);
            if (match) {
              personalizationContainer.dataset.numberOfKids = parseInt(
                match[1],
                10
              );
              if (personalizationFields.style.display === "block") {
                generateInputFields();                
              }
            }
          }

          // If "Color" changed, update the color data
          if (selector.name && selector.name.includes("Color")) {
            personalizationContainer.dataset.selectedColor =
              selector.dataset.rawValue;
            updatePersonalizationData();
          }

          // Preserve personalization state after variant change
          if (personalizationFields.style.display === "block") {
            setTimeout(preservePersonalizationState, 100);
          }
        }, 10);
      });
    });

    // Also update the other variant change event handlers similarly
    document.addEventListener("variant:changed", function (event) {
      if (event.detail && event.detail.variant) {
        updateCustomizerImage(event.detail.variant.id);

        const variant = event.detail.variant;
        const personalizationContainer = document.querySelector(
          ".product-personalization"
        );

        if (
          variant.options &&
          variant.option_names &&
          personalizationContainer
        ) {
          variant.options.forEach((option, index) => {
            const optionName = variant.option_names[index];
            const optionType = optionName.toLowerCase().includes("color")
              ? "color"
              : optionName.toLowerCase().includes("kids")
              ? "number_of_kids"
              : null;

            if (optionType) {
              // Find the selected input for this option type
              const selectedInput = document.querySelector(
                `input[type="radio"][data-option-type="${optionType}"]:checked`
              );

              if (selectedInput) {
                const rawValue = selectedInput.dataset.rawValue;

                if (optionType === "number_of_kids") {
                  const match = rawValue.match(/(\d+)/);
                  if (match) {
                    personalizationContainer.dataset.numberOfKids = parseInt(
                      match[1],
                      10
                    );
                    if (personalizationFields.style.display === "block") {
                      generateInputFields();
                    }
                  }
                } else if (optionType === "color") {
                  personalizationContainer.dataset.selectedColor = rawValue;
                  updatePersonalizationData();
                }
              }
            }
          });
        }

        if (
          personalizationFields &&
          personalizationFields.style.display === "block"
        ) {
          setTimeout(preservePersonalizationState, 100);
        }
      }
    });

    // 3. Direct click listener on variant option buttons
    const variantOptions = document.querySelectorAll(
      '.product-form__input input[type="radio"], .product-form__swatch input, .product-options button'
    );
    variantOptions.forEach((option) => {
      option.addEventListener("click", function () {
        setTimeout(() => {
          const variantId = productForm.querySelector('[name="id"]').value;
          updateCustomizerImage(variantId);
          // Check if this is a "Number of Kids" option
          if (
            (option.name && option.name.includes("Number of Kids")) ||
            option.getAttribute("data-option") === "Number of Kids"
          ) {
            const match = option.value
              ? option.value.match(/(\d+)/)
              : option.textContent.match(/(\d+)/);
            if (match) {
              personalizationContainer.dataset.numberOfKids = parseInt(
                match[1],
                10
              );
              if (personalizationFields.style.display === "block") {
                generateInputFields();
              }
            }
          }

          // Check if this is a "Color" option
          if (
            (option.name && option.name.includes("Color")) ||
            option.getAttribute("data-option") === "Color"
          ) {
            const color = option.value || option.textContent;
            personalizationContainer.dataset.selectedColor = color;
            updatePersonalizationData();
          }
        }, 50);
      });
    });
  }

  // Watch for changes to the main product image
  if (customizerImage) {
    const mainProductImage = document.querySelector(
      ".product__media-item.is-active img"
    );
    if (mainProductImage) {
      const observer = new MutationObserver(function (mutations) {
        customizerImage.src = mainProductImage.src;
        if (mainProductImage.srcset) {
          customizerImage.srcset = mainProductImage.srcset;
        }
        // updateCanvas will be called by the image load event
      });

      observer.observe(mainProductImage, {
        attributes: true,
        attributeFilter: ["src", "srcset"],
      });
    }

    // Watch for changes to the product media items
    const mediaGallery = document.querySelector("media-gallery");
    if (mediaGallery) {
      const observer = new MutationObserver(function (mutations) {
        const activeSlide = mediaGallery.querySelector(
          ".product__media-item.is-active img"
        );
        if (activeSlide) {
          customizerImage.src = activeSlide.src;
          if (activeSlide.srcset) {
            customizerImage.srcset = activeSlide.srcset;
          }
          // updateCanvas will be called by the image load event
        }
      });

      observer.observe(mediaGallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  // -- GLOBAL FUNCTION EXPORTS --
  // Make functions available globally to be called from other scripts
  window.updatePersonalizationFields = function () {
    if (
      personalizationFields &&
      personalizationFields.style.display === "block"
    ) {
      generateInputFields();
    } else if (personalizationFields.style.display === "none") {
      showPersonalizer();
    }
  };

  // Update color when it changes
  window.updatePersonalizationColor = function (color) {
    if (personalizationContainer) {
      personalizationContainer.dataset.selectedColor = color;
      updatePersonalizationData();
      // updateCanvas();
    }
    if (personalizationFields.style.display === "none") {
      showPersonalizer();
    }
  };

  // Initial setup
  if (customizerImage) {
    // Add initial load event to make sure we have the image before drawing text
    if (customizerImage.complete) {
      updateCanvas(); // Image already loaded
    } else {
      customizerImage.addEventListener("load", function onceLoaded() {
        updateCanvas();
        customizerImage.removeEventListener("load", onceLoaded);
      }); 
    }
  }

  // Add the event listener
  window.addEventListener("resize", applyTextOverlays());

  // To remove it later if needed
  window.removeEventListener("resize", applyTextOverlays());

  // Debounce function to limit how often a function runs
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
